import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import { DefaultDocument } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ManageDocumentDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Consulta los documentos para anular
   *
   * @returns {Observable<DefaultDocument[]>}
   * @memberof ManageDocumentDataService
   */
  getDefaultDocuments(): Observable<DefaultDocument[]> {
    return new Observable(obs => {
      this.http.get<DefaultDocument[]>(this.api.get('defaultDocument')).subscribe(
        res => {
          obs.next(res);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta los documentos anulados
   *
   * @returns {Observable<DefaultDocument[]>}
   * @memberof ManageDocumentDataService
   */
   getAnnuledDocuments(id_process: number): Observable<DefaultDocument[]> {
    return new Observable(obs => {
      this.http.get<DefaultDocument[]>(this.api.get('adminAnnulation', [id_process])).subscribe(
        res => {
          obs.next(res);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   *Agregar documentos anulables
   *
   * @param {number} id_process
   * @param {any[]} documents
   * @return {*}  {Promise<boolean>}
   * @memberof ManageDocumentDataService
   */
  annulDocuments(id_process: number, documents: any[]): Promise<boolean> {
    let formData = {
      id_tramite: id_process,
      documentos: documents
    }
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get("adminAnnulation"), formData).subscribe(
        (_resp) => {
          this.toastr.success("Registro realizado con éxito", 'Operación exitosa');
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/manage-documents/shared/manage-documents.data.service.ts